export default __webpack_public_path__ + "static/media/photo--sm--kara9.4d251e8d.jpg";